import * as Yup from 'yup';

const Validation = Yup.object({
    question: Yup.string().required("Required"),
    answer: Yup.string().required("Required"),
    // status: Yup.string().required("Required"),
});

export default Validation;
